import { db } from '../../common/config/Firebase';
import moment from 'moment';

/**
 * Fetches all time records for an employee on a specific date
 * @param {string} employeeId - Employee ID
 * @param {Date|number} date - Date to fetch records for (defaults to today)
 * @returns {Promise<Array>} - Array of time records sorted by timestamp (newest first)
 */
export const getTimeRecordsForDayUseCase = async (employeeId, date = new Date()) => {
    try {
        const targetDate = moment(date);
        const year = targetDate.format('YYYY');
        const month = targetDate.format('MM');

        const startOfDay = targetDate.startOf('day').valueOf();
        const endOfDay = targetDate.endOf('day').valueOf();

        const snapshot = await db
            .collection('timeRecords')
            .doc(employeeId)
            .collection(year)
            .doc(month)
            .collection('records')
            .where('timestamp', '>=', startOfDay)
            .where('timestamp', '<=', endOfDay)
            .orderBy('timestamp', 'desc')
            .get();

        const records = [];
        snapshot.forEach(doc => {
            records.push({
                id: doc.id,
                ...doc.data()
            });
        });

        console.log(`Fetched ${records.length} records for employee ${employeeId} on ${targetDate.format('YYYY-MM-DD')}`);
        return records;
    } catch (error) {
        console.error('Error fetching time records:', error);
        throw error;
    }
};
